export type MenuKey = 'summary' | 'inspirations' | 'destinations' | 'aboutUs'

export const useHeader = () => {
  const PAGE_WITHOUT_HEADER_STICKY = [
    'desktop:index',
    'mobile:index',
    'mobile:search',
  ]
  const PAGE_HEADER_WITHOUT_ANIMATION = ['search', 'destination-slug-filter']
  const PAGE_HEADER_SEARCH_HIDDEN = [
    'desktop:index',
    'mobile:index',
    'mobile:search',
  ]

  const { isSmallScreen } = useBreakpoint()
  const route = useRoute()
  const { userIsAdmin, userIsPartner } = useAuth()
  const { isLp } = useDestination()

  const header = useState<{
    languageCurrencyOpen: boolean
    menukey: MenuKey
    menuOpen: boolean
    searchMobileOpen: boolean
    signInChoiceOpen: boolean
  }>('header', () => ({
    languageCurrencyOpen: false,
    menukey: 'summary',
    menuOpen: false,
    searchMobileOpen: false,
    signInChoiceOpen: false,
  }))

  const height = computed(() => 72)
  const menuOpen = computed(() => header.value.menuOpen)
  const menuActiveKey = computed(() => header.value.menukey)
  const languageCurrencyOpen = computed(() => header.value.languageCurrencyOpen)
  const signInChoiceOpen = computed(() => header.value.signInChoiceOpen)
  const searchMobileOpen = computed(() => header.value.searchMobileOpen)

  const nameRoute = computed(() => getRouteName(route))

  const headerHandler = computed(() => {
    const isSticky =
      (!PAGE_WITHOUT_HEADER_STICKY.includes(`desktop:${nameRoute.value}`) &&
        !isSmallScreen.value) ||
      (isSmallScreen.value &&
        !PAGE_WITHOUT_HEADER_STICKY.includes(`mobile:${nameRoute.value}`))

    const isStickyWithAnimation =
      nameRoute.value === 'destination-name'
        ? isLp.value
        : !PAGE_HEADER_WITHOUT_ANIMATION.includes(nameRoute.value)

    return {
      isStickWithoutAnimation: isSticky && !isStickyWithAnimation,
      isStickyWithAnimation: isSticky && isStickyWithAnimation,
    }
  })

  const headerSearchHandler = computed(() => {
    const mobileCondition =
      nameRoute.value === 'destination-name'
        ? isLp.value
        : !PAGE_HEADER_SEARCH_HIDDEN.includes(`mobile:${nameRoute.value}`)

    const showSearch =
      (!PAGE_HEADER_SEARCH_HIDDEN.includes(`desktop:${nameRoute.value}`) &&
        !isSmallScreen.value) ||
      (mobileCondition && isSmallScreen.value)

    const showSearchAdminOrB2b2c =
      nameRoute.value === 'destination-name'
        ? isLp.value
        : !['destination-slug-filter', 'index', 'search'].includes(
            nameRoute.value,
          )

    return {
      showSearch:
        userIsAdmin.value || userIsPartner.value
          ? showSearchAdminOrB2b2c
          : showSearch,
    }
  })

  const setMenuOpen = (value: boolean) => {
    header.value.menuOpen = value
    header.value.menukey = 'summary'
  }
  const setLanguageCurrencyOpen = (value: boolean) => {
    header.value.languageCurrencyOpen = value
  }

  const setSignInChoiceOpen = (value: boolean) => {
    header.value.signInChoiceOpen = value
  }

  const setSearchMobileOpen = (value: boolean) => {
    header.value.searchMobileOpen = value
  }

  const setMenuNavigation = (key: MenuKey) => {
    header.value.menukey = key
  }

  return {
    headerHandler,
    headerSearchHandler,
    height,
    languageCurrencyOpen,
    menuActiveKey,
    menuOpen,
    searchMobileOpen,
    setLanguageCurrencyOpen,
    setMenuNavigation,
    setMenuOpen,
    setSearchMobileOpen,
    setSignInChoiceOpen,
    signInChoiceOpen,
  }
}
